<template>
  <a-modal
    :title="title"
    :width="modalWidth"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机">
          <a-input placeholder="请输入手机" v-decorator="[ 'phone', validatorRules.phone]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="邮箱">
          <a-input placeholder="请输入邮箱" v-decorator="[ 'email', {rules: [{ pattern: '^[A-Za-z0-9-_\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$', message: '请输入正确的邮箱号' }]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
export default {
  name: 'UserInfo',
  data() {
    return {
      record: {},
      title: '修改用户信息',
      modalWidth: 800,
      visible: false,
      confirmLoading: false,
      validatorRules: {
        phone: {
          rules: [
            {
              pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
              message: '请输入正确的手机号码!'
            }
          ]
        },
        email: {
          rules: [
            {
              pattern:/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
              message: '请输入正确的邮箱!'
            }
          ]
        }
      },

      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },

      form: this.$form.createForm(this),
      url: 'manager/users'
    }
  },
  methods: {
    show(record) {
      console.log(record)
      this.record = record
      this.form.resetFields()
      this.visible = true

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(record, 'phone', 'email'))
      })
    },
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.disableSubmit = false
      this.selectedRole = []
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let params = Object.assign(this.record, values)
          console.log(params)
          this.$http
            .put(this.url, params)
            .then(res => {
              
              if (res.code == 0) {
                this.$message.success(res.message)
                this.close()
              } else {
                this.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped>
</style>

